import * as React from 'react';
import * as styles from './common.module.scss';
import SearchIcon from '../../images/icons/search-icon';

interface Props {
  value: string;
  placeholder: string;
  updateValue: (val: string) => void;
  setIsSearching: (searching: boolean) => void;
  submitHandler?: () => void;
}

/**
 * SearchBar
 * @function SearchBar - Component for the search bar
 */
const SearchBar = ({ value, updateValue, setIsSearching, placeholder, submitHandler }: Props) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    submitHandler && submitHandler();
  };

  return (
    <div className={styles.searchBar}>
      <SearchIcon handleClick={event => handleSubmit(event)} />
      <form onSubmit={event => handleSubmit(event)}>
        <input
          value={value}
          onChange={(event: any) => updateValue(event.target.value)}
          onFocus={() => value && setIsSearching(true)}
          placeholder={placeholder}
        />
      </form>
    </div>
  );
};

export default SearchBar;
